<template>
  <div id="publicCourse" v-cloak>
    <van-overlay :show="isOverlay"  />
    
    <navigation style="background: #f3f3f4 !important;"></navigation>
    <div class="container">
      <div class="sidebarNav">
        <van-sidebar v-model="activeKey" >
          <van-sidebar-item v-for="item in publicTypes" :title="item.name" @click="initDataList(item.id,'1')"/>
        </van-sidebar>
      </div>
      <div class="" style="width:5.3rem;" >
            <div class="sidebarNavRight" style="width:5.3rem!important;">
              <div class="publicCourseType" v-for="item in courseList" @click="publicCourseIndex(item)">
                <div class="publicCourseTitle" >  
                  <img v-if="item.logo" :src="item.logo"/>
                  <img v-else src="../../../assets/img/kt.png"/>
                </div>
                <div class="publicCourseContent" >
                  <div class="publicCourseDesc">{{ item.name }}</div>
                  <div class="publicCourseTeacher">{{ item.lecturerName }}</div>
                </div>
              </div>  
            </div>
            <div class="baseline" v-if="isLoading">
               <van-loading />
            </div>
            <div class="baseline" v-if="!isLoading" >— 这是我的底线了 —</div>
      </div>
    </div>    
  </div>
</template>
<script> 
  let ff = false;
	import { Toast, Sidebar, List, SidebarItem, PullRefresh,Overlay,Tab, Tabs, Cell,Loading  } from 'vant'
	import request from '@/utils/request'
	import navigation from "../../components/nav";
	export default {
		components: {
      navigation,
      [Toast.name]: Toast,
      [Sidebar.name]: Sidebar,
      [List.name]: List,
      [SidebarItem.name]: SidebarItem,
      [PullRefresh.name]: PullRefresh,
      [Overlay.name]: Overlay,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Cell.name]: Cell,
      [Loading.name]: Loading 
		},
		data() {
			return {
        id:'',
        noDate:false,//这是一个判断是否加载的开关
        pageNum:0,
        pageSize:10,
        offset: 0,
        isWc:'— 这是我的底线了 —',
        recordCount:Number,//数据总数
        activeKey: 0,
        count: 0,
        isLoading: true,
        list: [],
        loading: false,//控制上拉加载的加载动画
        finished: false,//控制在页面往下移动到底部时是否调用接口获取数据
        publicTypes:[],//公开课分类数组
        courseList:[],//公开课列表
        publicCourse1:[],
        publicCourse:[
          { logo:require('../../../assets/img/kt.png'), name:'交通标志运输企业的沙发斯蒂芬安ddddd全标准大改版',lecturerName:'安老师 白老师'},
          { logo:require('../../../assets/img/kt.png'), name:'交通标志运输企业安全标准大改版',lecturerName:'安老师 白老师'},
          { logo:require('../../../assets/img/kt.png'), name:'交通标志运输企业安全标准大改版',lecturerName:'安老师 白老师'},
          { logo:require('../../../assets/img/kt.png'), name:'交通标志运输企业安全标准大改版',lecturerName:'安老师 白老师'},
          { logo:require('../../../assets/img/kt.png'), name:'交通标志运输企业安全标准大改版',lecturerName:'安老师 白老师'},
          { logo:require('../../../assets/img/kt.png'), name:'交通标志运输企业安全标准大改版',lecturerName:'安老师 白老师'}
        ],
        bootomC:'',
        isOverlay:false,//遮罩层是否显示
        stop:true,
			}
    },
    mounted(){
      var _this = this;
      //window.scrollTo(0,-200); 
      //_this.pageNum = 1;
      this.initDataTypeList();//公开课分类列表
      window.onscroll = function(){
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
          let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
            //console.log(scrollHeight+"==="+scrollTop+"==="+clientHeight)
          if(scrollHeight-scrollTop-clientHeight < 100 && ((_this.pageNum-1)*_this.pageSize < _this.recordCount)){
            // if(scrollHeight > clientHeight 
            // && Math.ceil(scrollTop + clientHeight) === scrollHeight 
            // || (Math.ceil(scrollTop + clientHeight)-scrollHeight==1)
            // || (Math.ceil(scrollTop + clientHeight)-scrollHeight>1)&&(Math.ceil(scrollTop + clientHeight)-scrollHeight<50)){ 
            if(_this.stop){
              _this.stop = false
             // _this.pageNum ++;
              _this.initDataList1(_this.id)
            }
          }
          return;
          if(scrollHeight > clientHeight 
            && Math.ceil(scrollTop + clientHeight) === scrollHeight 
            || (Math.ceil(scrollTop + clientHeight)-scrollHeight==1)
            || (Math.ceil(scrollTop + clientHeight)-scrollHeight==2)
            || (Math.ceil(scrollTop + clientHeight)-scrollHeight>2)&&(Math.ceil(scrollTop + clientHeight)-scrollHeight<50)) {
              _this.initDataList1(_this.id)
          }
        }
   },
		methods: {
      onLoad() { 
        //this.pageNum += 1;
        this.offset = this.pageSize * this.pageNum;
        if(!ff){
          //this.initDataTypeList();
        }else{
          //this.initDataList1(this.id)
        }
      },
      publicCourseIndex(item){//公开课首页
        this.$router.push({name: 'PublicCourse',query: {courseId:item.id,category:3,channeFlag:2} })
      },
      initDataTypeList() {
				let _this = this;
				let url = Global.env + Global.apiCore.openCourseCategory;
				return new Promise((resolve, reject) => {
					request({
						url: url,
						method: 'get', //查询一般为get
					}).then(response => {
						if (response.resultCode === "1000") {
							if (response && response.data) {
								let dataObj = response.data;
                _this.publicTypes = dataObj;
                _this.id = dataObj[0].id || '';
                _this.pageNum = 1;
                _this.initDataList1(dataObj[0].id||'',1)

							}
							return resolve()
						} else {
							return reject(response.resultDesc);
						}
					}).catch(error => {
						return reject(error);
					})
				})
      },
      
      initDataList1(id) { //type 1 初始化数据  2 切换tab存储数据id
        
				let _this = this;
				this.isLoading = true; 
        let url = Global.env + Global.apiCore.coursePageList;
        let categoryId = '';
        categoryId = id;
        console.log(_this.pageNum)
				return new Promise((resolve, reject) => {
					request({
						url: url,
            method: 'get', //查询一般为get
            params:{pageNum:_this.pageNum,pageSize:this.pageSize,categoryId:categoryId}
					}).then(response => {
						if (response.resultCode === "1000") {
							if (response && response.data) {
                  _this.isOverlay = false;
                  let dataObj = response.data;  
                  _this.recordCount = dataObj.total;
                    if (dataObj.list.length) {
                        _this.courseList.push(...dataObj.list)
                        let obj = {};
                      _this.courseList = _this.courseList.reduce(function(item, next) {
                          obj[next.id] ? '' : obj[next.id] = true && item.push(next);
                          return item;
                      }, []);
                       //console.log(_this.courseList)
                       // _this.courseList.push(...dataObj.list)
                    }
                    if(_this.courseList.length == dataObj.total){  
                      this.setTimeLen();
                    }else{
                      if(dataObj.list.length ==0){
                       this.setTimeLen();
                      }
                    }
                    if(dataObj.total <11 && _this.pageNum ==1){
                      this.setTimeLen();
                    }
                   _this.pageNum ++;
                  _this.stop = true;
							}
							return resolve()
						} else {
							return reject(response.resultDesc);
						}
					}).catch(error => {
						return reject(error);
					})
				})
			},
			setTimeLen(){
				setTimeout(() => {
					this.isLoading = false;
				}, 2000);
			},
      initDataList(id) { 
        this.pageNum = 1;
        this.id = id;
        this.isOverlay = true;
        this.courseList = [];
        // this.finished = false;
				// this.loading = true;
				this.isLoading = true;
        this.initDataList1(id,2);
      },
    }
  }
</script>
<style lang="scss">
  #publicCourse{
    ._v-container[data-v-ecaca2b0]{
       position: absolute !important;
       margin-left: 2rem;
       margin-top: 1.4rem;
       width: 5.5rem !important;
      height: auto;
    }
    .pull-to-refresh-layer{
      margin-left: 0 !important;
    }
    .loading-layer{
      margin-left: 0 !important;
    }
    .container{
      display: flex;
      height: auto;
    }
    .sidebarNav{
      margin-left: .04rem;
      .van-sidebar{
        width: 1.86rem;
      }
      .van-sidebar-item{
        width: 1.84rem;
        height: 1.24rem;
        line-height: .62rem;
        background-color: #f3f3f4;
        padding: 0 0.16rem 0.26rem 0.06rem;
      }
      .van-sidebar-item--select{
        border-color: #fff;
        background-color: #fff;
         &:before {
          content: "";
          width: .06rem;
          height: .64rem;
          position: absolute;
          left: 0;
          margin-top: .32rem;
          background: #F63C45;
        }
        .van-sidebar-item__text{
          text-align: center;
          color:#F63C45;
        }
      }
      .van-sidebar-item__text{
        display: flex;
        flex-direction: column;
        width: 1.7rem;
        height: 1.2rem;
        //align-items: center;//垂直居中
        justify-content: center;//水平居中
        font-size: .3rem;
        color: #333;
        text-align: center;
      }
    }
    .sidebarNavRight{
       height: auto;
      width: 0 !important;
      overflow: auto;
      margin-left: .12rem;
      margin-top: .2rem;
      .publicCourseType{
        padding: .1rem 0 .08rem !important;
        border-bottom: 0.01rem solid #f7f8fa;
        height: 1.8rem;
        overflow: hidden;
      }
      .publicCourseTitle{
        & img{
          float: left;
          width: 1.76rem;
          height: 1.76rem;
          border-radius: 8px !important;
        }
      }
      .publicCourseContent{
        height: 1.8rem;
        margin-left: 1.9rem !important;
        margin-top: .26rem;
        .publicCourseDesc{
          font-size: .30rem;
          width: 3.4rem;
          color: #333;
          line-height: 0.38rem;

          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          display: box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .publicCourseTeacher{
          margin-top: .18rem;
          font-size: .26rem;
          width: 3.4rem;
          color: #999;
        }
      }
    }
    .van-list__finished-text{
      font-size: .26rem;
    }
    .van-list__loading{
      .van-loading__text{
        font-size: .26rem;
      }
    }
    .baseline {
      width: 100%;
      height: 0.8rem;
      line-height: 0.8rem;
      text-align: center;
      font-size: 0.26rem;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
    }
  }
</style>